/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createDemandRequestSchema = z.object({
  demandStatusId: z.int().nullish(),
  description: z.string().nullish(),
  ownerId: z.string().nullish(),
  targetLoopId: z.int().nullish(),
  title: z.string(),
});
